import { mapActions } from 'vuex'
import TipoAgendamento from '@/utils/agendamento'
import { exportComprovantePDF } from '@/services/pdf/PdfService';
import { applyPdfStyle } from '@/services/pdf/agendamento/template';

export const methods = {
  async imprimirComprovante() {
    setTimeout(window.print, 500)
  },
  ...mapActions('patio', ['getAgendamentoGerenciamentoServico']),
  ...mapActions('template', ['errorMessage']),
  async handleGerarTriagem(item) {
    try {
      const agendamento = await this.getAgendamentoGerenciamentoServico({
        public_id: item.public_id,
      })
      agendamento.isEdicao = false
      agendamento.isEdicaoTriagem = false
      this.$router.push({
        name: 'NovaTriagem',
        params: {
          agendamentoSelecionado: agendamento,
          tipoAgendamento: TipoAgendamento.Triagem,
        },
      })
    } catch (error) {
      console.log(error)
      this.errorMessage('Agendamento não encontrado!')
    }
  },

  async exportPDF() {
    if (this.exportingPDF) return;
    this.exportingPDF = true;

    try {
      const element = this.$refs.exportpdf?.$el || this.$refs.exportpdf;
      await exportComprovantePDF(
        element, `comprovante-agendamento-${this.agendamento.public_id}.pdf`, applyPdfStyle
      );
    } catch (error) {
      console.error(error);
    } finally {
      this.exportingPDF = false;
    }
  }
}
